import { voltFetch } from "../voltApi";
import type { IdeaChange, IdeaHandover, IdeaPage, IdeaSaved } from "./types";

const call = <T>(path: string, init?: RequestInit) =>
  voltFetch<T>(`/ideas/api${path}`, init);

export const ideasApi = {
  access: () => call<{ ok: boolean }>("/access"),
  list: (params: Record<string, string>, offset: number, limit: number) => {
    const q = new URLSearchParams({
      ...params,
      offset: String(offset),
      limit: String(limit),
    });
    return call<IdeaPage>(`/list?${q}`);
  },
  change: (id: number, version: number, change: IdeaChange) =>
    call<IdeaSaved>(`/candidates/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ ...change, version }),
    }),
  toWorkshop: (id: number, version: number) =>
    call<IdeaHandover>(`/candidates/${id}/workshop`, {
      method: "POST",
      body: JSON.stringify({ version }),
    }),
};
